import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './PdpSharedBlurb.scss';

// helpers
import classnames from 'classnames';

export function PdpSharedBlurb({
    IconComponent,
    printHide,
    dataTn,
    children,
    iconClass,
    hideIcon,
}) {
    return (
        <div
            className={classnames(styles.wrapper, { [styles.printHide]: printHide })}
            data-tn={dataTn}
        >
            {!hideIcon && (
                <div className={classnames(styles.icon, iconClass)}>
                    <IconComponent />
                </div>
            )}
            <div className={styles.text}>{children}</div>
        </div>
    );
}

PdpSharedBlurb.propTypes = {
    iconClass: PropTypes.string,
    IconComponent: PropTypes.func.isRequired,
    printHide: PropTypes.bool,
    children: PropTypes.node,
    dataTn: PropTypes.string,
    hideIcon: PropTypes.bool,
};
